export class BulkStepsDTO 
{
	goalId?   : number
	quantity? : number
	moment?   : Date
	note?     : string
	kidGoalIds : number[] = []
}
